// This is a customisation of the accordion-group directive in ui bootstrap
// v0.12.0 to fix an issue in ie8. Replace has been changed from true to false

import accordionGroupTemplate from './accordion-group.html';

angular.module('BBPublicBooking')

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
    .directive('bbAccordionGroup', () => {
        return {
            require: '^accordion',         // We need this directive to be inside an accordion
            restrict: 'EA',
            transclude: true,              // It transcludes the contents of the directive into the template
            replace: false,                // The element containing the directive will be replaced with the template
            templateUrl: accordionGroupTemplate.id,
            scope: {
                heading: '@',               // Interpolate the heading attribute onto this scope
                isOpen: '=?',
                isDisabled: '=?'
            },
            controller() {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            },
            link(scope, element, attrs, accordionCtrl) {
                accordionCtrl.addGroup(scope);

                scope.$watch('isOpen', (value) => {
                    if (value) {
                        accordionCtrl.closeOthers(scope);
                    }
                });

                scope.toggleOpen = function () {
                    if (!scope.isDisabled) {
                        scope.isOpen = !scope.isOpen;
                    }
                };
            }
        };
    })

    // Use accordion-heading below an accordion-group to provide a heading containing HTML
    // <accordion-group>
    //   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
    // </accordion-group>
    .directive('bbAccordionHeading', () => {
        return {
            restrict: 'EA',
            transclude: true,   // Grab the contents to be used as the heading
            template: '',       // In effect remove this element!
            replace: true,
            require: '^bbAccordionGroup',
            link(scope, element, attr, accordionGroupCtrl, transclude) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, () => {
                }));
            }
        };
    })

    // Use in the accordion-group template to indicate where you want the heading to be transcluded
    // You must provide the property on the accordion-group controller that will hold the transcluded element
    // <div class="accordion-group">
    //   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
    //   ...
    // </div>
    .directive('bbAccordionTransclude', () => {
        return {
            require: '^bbAccordionGroup',
            link(scope, element, attr, controller) {
                scope.$watch(() => {
                    return controller[attr.bbAccordionTransclude];
                }, (heading) => {
                    if (heading) {
                        element.html('');
                        element.append(heading);
                    }
                });
            }
        };
    });



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/accordion-group/bb_accordion_group.directive.js